export const FETCH_ALL_NEWSLETTERS = "FETCH_ALL_NEWSLETTERS";
export const FETCH_NEWSLETTER = "FETCH_NEWSLETTER";
export const CREATE_NEWSLETTER = "CREATE_NEWSLETTER";
export const UPDATE_NEWSLETTER = "UPDATE_NEWSLETTER";
export const DELETE_NEWSLETTER = "DELETE_NEWSLETTER";